<script setup lang="ts">
import { useTitle } from '@vueuse/core';

useTitle('Сторінку не знайдено');

const error = {
  statusCode: 404,
  statusMessage: 'Не знайдено',
  message: 'Сторінки, яку ви шукаєте, не існує.',
};
</script>

<template>
  <UError
    :error="error"
    :clear="false"
    data-testid="error-page-404"
  >
    <template #links>
      <RouterLink :to="{ name: 'Home' }">
        <UButton
          size="lg"
          color="primary"
          label="На головну"
          data-testid="error-back-to-home-button"
        />
      </RouterLink>
    </template>
  </UError>
</template>
